import { react2panel } from 'common/util/react2panel';
import { ChartTooltip } from './index';
export const ChartTooltipEl = react2panel("mp-chart-tooltip", ChartTooltip);